import {action, computed, observable} from 'mobx';
import {ChangePasswordState} from './states/change-password/change-password.state';
import {BrowserNotSupportedState} from './states/browser-not-supported/browser-not-supported.state';
import {IHistoryConsoleResult} from './states/history-console/controller';
import {IPasswordSettings, GeneralSettings} from './models/AccountSettings';

export interface IAppUser {
    _id: string;
    firstName: string;
    lastName: string;
    role: string;
    lastLogin: number;
}

export class AppState {
    @observable private _appUser?: IAppUser;

    @observable private _offlineRoomCount?: string;

    @observable private _pendingRoomCount?: string;

    @observable private _selectedMultiAccount: string = '';

    @observable showGlobalLoader: boolean = false;

    @observable accountId: string = '';

    @observable accountName: string = '';

    @observable dashboardLanguage: string = '';

    @observable changePasswordState: ChangePasswordState = new ChangePasswordState();

    @observable browserNotSupportedState: BrowserNotSupportedState = new BrowserNotSupportedState();

    @observable historyConsoleSessionsResults: IHistoryConsoleResult[] = [];

    @observable historyConsoleTotalResults: number = 0;

    passwordSettings: IPasswordSettings = {} as IPasswordSettings;

    generalSettings: Partial<GeneralSettings> = {};

    accountLanguage: string = 'en-US';

    @computed get agentId(): string {
        return this.appUser ? this.appUser._id : '';
    }

    @computed get agentRole(): string {
        return this.appUser ? this.appUser.role : '';
    }

    @computed get selectedMultiAccount(): string {
        return this._selectedMultiAccount;
    }

    @computed
    get agentFullName(): string {
        if (!this._appUser) {
            return '';
        }

        return `${this._appUser.firstName} ${this._appUser.lastName}`;
    }

    @computed
    get appUser(): Readonly<IAppUser> | undefined {
        return this._appUser;
    }

    @action
    setSelectedMultiAccount(selectedMultiAccount: string): void {
        this._selectedMultiAccount = selectedMultiAccount;
    }

    @action
    setAppUser(user: IAppUser): void {
        this._appUser = user;
    }

    @action
    setAgentSettings(
        passwordSettings: IPasswordSettings,
        generalSettings: Partial<GeneralSettings>,
        accountLanguage: string
    ): void {
        this.passwordSettings = passwordSettings;
        this.generalSettings = generalSettings;
        this.accountLanguage = accountLanguage;
    }

    @computed
    get offlineRoomCount(): string | undefined {
        return this._offlineRoomCount;
    }

    @computed
    get pendingRoomCount(): string | undefined {
        return this._pendingRoomCount;
    }

    @action
    setOfflineRoomCount(offlineRoomCount: number): void {
        this._offlineRoomCount = `${offlineRoomCount}`;
    }

    @action
    setPendingRoomCount(pendingRoomCount: number): void {
        this._pendingRoomCount = `${pendingRoomCount}`;
    }
}
